// extracted by mini-css-extract-plugin
export default {"scrim":"DockCardScrim_scrim__dDzHF","scrimIn":"DockCardScrim_scrimIn__ZYFCi","blur":"DockCardScrim_blur__m9+ce","tint":"DockCardScrim_tint__NdOBD"};